import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'VendorIcon',
  viewBox: '0 0 16 16',
  defaultProps: {
    boxSize: 4,
  },
  path: (
    <path
      d="M1.703 6.433v7.35c0 .706.503 1.217 1.206 1.217h10.182c.703 0 1.206-.511 1.206-1.217v-7.35M15 4.757v-1.84A1.913 1.913 0 0 0 13.09 1H2.91C1.854 1 1 1.858 1 2.917v1.84C1 6.212 2.35 7.39 4.182 7.39c.681 0 1.191-.359 1.718-.639.527.28.827.64 2.1.64 1.273 0 1.573-.36 2.1-.64.527.28 1.037.64 1.718.64C13.65 7.391 15 6.211 15 4.756ZM10.386 15v-4.297c0-.77-.621-1.394-1.388-1.394H7.32c-.767 0-1.388.624-1.388 1.394V15h4.454Z"
      stroke="currentColor"
      strokeWidth="1.3"
      fill="none"
    />
  ),
});
